import React from "react"
import styled from "styled-components"
import { Link, useStaticQuery, graphql } from "gatsby"
import { device } from "../../theme"

const StyledUl = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  margin-top: 22px;
`

const StyledLi = styled.li`
  color: #444;
  font-size: 0.9rem;
  cursor: pointer;
  margin-left: 12px;
  transition: transform 0.1s ease-in-out;

  @media ${device.phone} {
    font-size: 1.1rem;
  }

  &:hover {
    font-weight: bold;
    transform: translateX(4px);
  }
`

const StyledLink = styled(Link)`
  color: #000;

  &:hover {
    color: ${props => props.theme.colors.green};
  }

  &.selected-dealer {
    text-decoration: underline;
    color: ${props => props.theme.colors.green};
  }
`

function Shop({ active, gender }) {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark(sort: { fields: frontmatter___shop }) {
        edges {
          node {
            id
            frontmatter {
              gender
              url
              shop
            }
          }
        }
      }
    }
  `)

  return (
    <StyledUl>
      {data.allMarkdownRemark.edges.map(e => {
        if (e.node.frontmatter.gender === gender) {
          return (
            <StyledLi key={e.node.frontmatter.shop}>
              <StyledLink
                className={
                  active === e.node.frontmatter.shop ? "selected-dealer" : ""
                }
                to={e.node.frontmatter.url}
              >
                {e.node.frontmatter.shop}
              </StyledLink>
            </StyledLi>
          )
        }

        return null
      })}
    </StyledUl>
  )
}

export default Shop
